import System from "src/helper/system";
import HCLDX from "./hcldx";

class Profile {
    static PROFILE_ACCOUNT_INFORMATION = System.getProfileUrl() + '/api/user/apac/profile';
    static SET_CONTACT_INFORMATION = System.getAdminConsoleUrl() + '/api/user/apac/edituser';
    static GET_JOBFUNCTION_LIST = System.getApplicationUrl() + '/api/application/reference/all/Jobfunction';
    static HEADER_ACCOUNT_LIST = System.getProfileUrl() + '/api/user/current/account';
    static PROFILE_ADDRESS_URL = System.getBaseUrl() + `/api/user/apac/shippingAddress`;
    static GET_COUNTRY_LIST = System.getBaseUrl() + `/api/reference/countryData`;
    static GET_CARRIER_DATA_LIST = System.getBaseUrl() + `/api/reference/carrierDataAPAC`;
    static GET_STATE_LIST = System.getBaseUrl() + `/api/reference/statesData`;
    static SET_ACCOUNT_LINK_INFORMATION = System.getProfileUrl() + '/api/user/apac/sendEmailToLinkExistingAccount';

    static getProfileURL() {
        return HCLDX.baseURL() + "/resources/my-avnet/profile";
      }

    static getLinkToExistingAccountURL() {
      return HCLDX.baseURL() + "/resources/my-avnet/link-to-existing-account";
    }
}

export default Profile;